import type { ReferenceImage, RefCharacter, RefLocation, RefProp } from "@/components/shot-references-panel"

/** Герой кадра с картинкой из reference_images (по имени). */
export function shotRefCharacter(images: ReferenceImage[], name: string, subtitle: string | null): RefCharacter {
  const ref = images.find((row) => row.type === "character" && row.name === name)
  return {
    name,
    imageUrl: ref?.url ?? null,
    downloadUrl: ref?.download_url ?? null,
    subtitle,
    appearanceUpdated: ref?.appearance_updated === true,
  }
}

export function shotRefProps(images: ReferenceImage[]): RefProp[] {
  return images
    .filter((row) => row.type === "prop")
    .map(
      (row): RefProp => ({
        name: row.name,
        subtitle: row.subtitle,
        imageUrl: row.url,
        downloadUrl: row.download_url ?? null,
        frontViewChrome: row.front_view_chrome === true,
        appearanceUpdated: row.appearance_updated === true,
      }),
    )
}

/** Локация кадра; null, если у кадра нет ни локации, ни варианта. */
export function shotRefLocation(
  images: ReferenceImage[],
  locationName: string | null,
  variantName: string | null,
): RefLocation | null {
  if (!locationName && !variantName) return null
  const ref = images.find((row) => row.type === "location")
  const name = locationName ?? ""
  return {
    name,
    subtitle: variantName !== name ? variantName : null,
    imageUrl: ref?.url ?? null,
    downloadUrl: ref?.download_url ?? null,
  }
}
